/**
 * Rich text node helpers — no registry / blocks-registry imports.
 */

import { resolveBlockType } from '../registry/block-type-resolve'

export const RICHTEXT_TEXT_TYPES = Object.freeze(['h3', 'p', 'blockquote'])

/** Block types that cannot be nested inside Rich Text */
export const RICHTEXT_EMBED_EXCLUDED = new Set([
  'block_richtext',
  'block_tabs',
  'block_badge',
  'block_hero',
  'block_card',
  'block_supporting_notes',
])

export function newRichTextId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `rt-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
}

export function isRichTextTextNode(node) {
  return Boolean(node && RICHTEXT_TEXT_TYPES.includes(node.type))
}

export function isRichTextEmbedNode(node) {
  if (!node || typeof node !== 'object') return false
  if (node.type === 'embed' && node.blockType) return true
  return typeof node.type === 'string' && node.type.startsWith('block_')
}

export function getEmbedBlockType(node) {
  if (!node) return null
  if (node.type === 'embed') return resolveBlockType(node.blockType)
  if (typeof node.type === 'string' && node.type.startsWith('block_')) {
    return resolveBlockType(node.type)
  }
  return null
}

export function getEmbedData(node) {
  if (!node || typeof node !== 'object') return {}
  if (node.data && typeof node.data === 'object') return node.data
  return {}
}
